export default function initMenu() {
    let navOpen = document.getElementById('nav-open');
    let navClose = document.getElementById('nav-close');
    let offcanvasMenu = document.getElementById('offcanvas-menu');


    navOpen.addEventListener('click', function () {
        offcanvasMenu.style.transform = 'translateX(0)';
    });

    navClose.addEventListener('click', function () {
        offcanvasMenu.style.transform = 'translateX(100%)';
    });

    document.addEventListener('click', function (event) {
        if (!offcanvasMenu.contains(event.target) && !navOpen.contains(event.target) && !navClose.contains(event.target)) {
            offcanvasMenu.style.transform = 'translateX(100%)';
        }
    });
}
